/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm, replacePXinStringWithEM, answerSelect, answerError } from 'utils/styles/style_helpers';



/* ++++++++++ --------------- EXPORT --------------- ++++++++++ */
// EMBED : ANSWER TEXT 1 : STYLES
// utliizes utils and CSS-IN-JS (JS objects converted to CSS using a library)
export default theme => ({
	text1: {
		cursor: 'pointer',
		position: 'relative',
		zIndex: '3',
		textAlign: 'left',
		display: 'block',
		height: pxToEm(36),
		margin: replacePXinStringWithEM(`0 auto 7px`),
		boxShadow: replacePXinStringWithEM('0 1px 2px 0 rgba(0,0,0,0.10), inset 0 -1px 2px 0 rgba(173,173,173,0.40)'),
		borderRadius: pxToEm(3),
		padding: replacePXinStringWithEM('0px 10px'),
		'& .background': {
			background: 'rgba(255,255,255,.9)',
			borderRadius: 'inherit',
			width: '100%',
			height: '100%',
			position: 'absolute',
			top: '0',
			left: '0',
			zIndex: '1',
			transition: 'background .2s linear 0s',
			extend: answerSelect,
			'&.selected-false.valid-false': {
                extend: answerError.text
			}
		},
		'& .text': {
			// background: 'radial-gradient(ellipse at center, rgba(255,255,255,1) 0%, rgba(255,255,255,1) 15%, rgba(255,255,255,0) 69%, rgba(255,255,255,0) 100%)',
			color: '#4A4A4A',
			display: 'flex',
			alignItems: 'center',
			width: '100%',
			height: '100%',
			position: 'relative',
			zIndex: '2'
		},
		'& .text.medium': {
			fontSize: pxToEm(14)
		},
		'& .text.standard': {
			fontSize: pxToEm(16)
		},
		'&:hover': {
            '& .background': {
                background: 'rgba(255,255,255,.7)'
            }
        }
	}
});